import { z } from 'zod'
import { TrueFalse } from '~/enums/true-false'

/**
 * 產品主類目 - 查詢單筆 Request Schema
 */
export const getProductMainRequestSchema = z.object({
  /** 是否上架 */
  isEnable: z.array(z.nativeEnum(TrueFalse)).optional()
})

/**
 * 產品主類目 - 查詢單筆 Request
 */
export interface GetProductMainRequest
  extends z.infer<typeof getProductMainRequestSchema> {}
